import { render, staticRenderFns } from "./IdeaVr.vue?vue&type=template&id=cd279416&scoped=true&"
import script from "./IdeaVr.vue?vue&type=script&lang=js&"
export * from "./IdeaVr.vue?vue&type=script&lang=js&"
import style0 from "./IdeaVr.vue?vue&type=style&index=0&id=cd279416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd279416",
  null
  
)

export default component.exports